import { inject, Injectable } from '@angular/core';

import { of } from 'rxjs';

import { I18nService } from '@core/i18n-legacy';
import type { DataSourceService } from '@core/views-types';
import { TicketService } from '@tellent-ask-hr/tickets-logic';

import { TicketDialogService } from '../ticket-dialog.service';

@Injectable()
export class UserTicketsDataSourceService implements DataSourceService {
  private readonly i18n = inject(I18nService);
  private readonly ticketDialogService = inject(TicketDialogService);
  private readonly ticketService = inject(TicketService);

  public hasMoreSettings$ = of(true);
  public hasSampleData$ = of(false);
  public isSampleDataInProgress$ = of(false);
  public viewPageHeaderComponent$ = of(null);
  public pageCtaVisible$ = of(false);

  public refreshData$ = this.ticketService.getViewsRefreshEvents$();
  public translations = {
    dataSourceName: 'app.views_candidates.name',
    pageCta: 'app.views_candidates.view_add_candidate',
  };

  public defaultEmptyState$ = of({
    header: this.i18n.translate('tlc.ask_hr.user_requests.empty_state.heading'),
    description: this.i18n.translate('tlc.ask_hr.user_requests.empty_state.subheading'),
    icon: <const>'local-activity',
  });

  public filteredEmptyState$ = of({
    header: '',
    description: '',
    icon: <any>'',
  });

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onRemoveSampleData = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onPageCtaClick = () => {};

  public onRecordClick = (ticket: { id: number }) => {
    this.ticketDialogService.openTicketDialog(ticket.id);
  };
}
